export const SET_REPORT_FILTER_INFOS = "REPORT_FILTER_INFOS/SET_REPORT_FILTER_INFOS";
export const SET_REPORT_OF_ATTENDANCES = "REPORT_OF_ATTENDANCES/SET_REPORT_OF_ATTENDANCES";
export const SET_EMPLOYEE_REPORT = "EMPLOYEE_REPORT/SET_EMPLOYEE_REPORT";
export const SET_SERVICES_REPORT = "SERVICES_REPORT/SET_SERVICES_REPORT";